/**
 * FLARE Platform — Centralized Configuration
 *
 * Detects runtime environment (web, Tauri desktop, Capacitor mobile) and
 * exports the correct API URL, app URL, and platform flags.
 */

// Tauri 2.0 injects this global at startup
export const IS_TAURI =
  typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;

// Capacitor detection — check for the native bridge object
// Fallback: Capacitor Android loads from https://localhost with NO port
// (Vite dev with --https uses https://localhost:5173 — the port check excludes it)
export const IS_CAPACITOR =
  typeof window !== 'undefined' && (
    !!window.Capacitor ||
    (window.location.protocol === 'https:' && window.location.hostname === 'localhost' && !window.location.port)
  );

// True when running inside any native container
export const IS_NATIVE = IS_TAURI || IS_CAPACITOR;

// Resolve API base URL
//   Native:     always hit the production API directly (no proxy)
//   Production: hostname contains 'flare-social'
//   Dev:        Vite proxy at /api -> localhost:8000
export const API_URL =
  IS_NATIVE
    ? 'https://api.flare-social.com'
    : window.location.hostname.includes('flare-social')
      ? 'https://api.flare-social.com'
      : '/api';

// OAuth entry URLs — native apps tell the backend to redirect to flare://
export const OAUTH_GOOGLE_URL = IS_NATIVE
  ? `${API_URL}/auth/oauth/google?redirect_to=native`
  : `${API_URL}/auth/oauth/google`;

export const OAUTH_GITHUB_URL = IS_NATIVE
  ? `${API_URL}/auth/oauth/github?redirect_to=native`
  : `${API_URL}/auth/oauth/github`;
